var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection_task"},[(_vm.collection_task_list.length)?_vm._l((_vm.collection_task_list),function(item,index){return _c('design_item',{key:index,attrs:{"itemObj":item}})}):_c('div',{staticClass:"no_List"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }